<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-receptionist"
      entity-name="内部人员"
      add-btn="添加"
      hide-show-detail
      :before-update="beforeUpdate"
      :custom-url="customUrl"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:button>
        <a-button @click="importStaff"><a-icon type="upload" />批量导入</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入姓名或手机号码查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入内部人员姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入内部人员手机号码"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="内部人员导入模板.xlsx"
      url="https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/staff_template.xlsx"
      import-url="/activity/activity-receptionist/work-import"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import batchImportModal from "../components/batch-import-modal";
    export default {
        name: "Insider",
        components: {
            batchImportModal
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入内部人员姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入内部人员手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ]
                },
                query: "&filter[type]=2&filter[activity_id]=0",
                visible: false,
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.type = 2;
                    form.activity_id = 0;
                }
                fn();
            },
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            importStaff() {
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
